import { FormattedMessage } from 'react-intl';
import { InfoCircle } from 'iconsax-react';
import { NavItemType } from 'types/menu';

const icons = { InfoCircle };

// ==============================|| MENU ITEMS - category ||============================== //

export const SuperAdminErrorLogs: NavItemType = {
  id: 'ErrorLogs',
  type: 'group',
  name: 'ErrorLogs',
  icon: icons.InfoCircle,
  children: [
    {
      icon: icons.InfoCircle,
      id: 'ErrorLogs',
      title: <FormattedMessage id="Error Logs" />,
      type: 'item',
      url: '/superadmin/errorLogs'
    }
  ]
};
